import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ToneOfVoiceAnalyzerPopup = loadAsyncComponent(() => import('./Container'), 'popup');
